import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { EXCHANGE_DISPLAY_NAMES, EXCHANGE_PRICE_NOTES } from '@/types'

interface ExchangeBadgeProps {
  exchange: string
  className?: string
  size?: 'default' | 'sm'
}

const exchangeStyles: Record<string, string> = {
  binance: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  binance_alpha: 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30',
  bitget: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  bybit: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  okx: 'bg-zinc-500/20 text-zinc-300 border-zinc-500/30',
  gate: 'bg-teal-500/20 text-teal-400 border-teal-500/30',
  kucoin: 'bg-green-500/20 text-green-400 border-green-500/30',
  mexc: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  asterdex: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  hyperliquid: 'bg-lime-500/20 text-lime-400 border-lime-500/30',
  lighter: 'bg-sky-500/20 text-sky-400 border-sky-500/30',
  bitunix: 'bg-violet-500/20 text-violet-400 border-violet-500/30',
  whitebit: 'bg-zinc-500/20 text-zinc-200 border-zinc-500/30',
  bingx: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  lbank: 'bg-lime-500/20 text-lime-400 border-lime-500/30',
  kraken: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  upbit: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  coinbase: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  bithumb: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  bitfinex: 'bg-green-500/20 text-green-400 border-green-500/30',
  weex: 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30',
}

export function ExchangeBadge({ exchange, className, size = 'default' }: ExchangeBadgeProps) {
  const ex = exchange.toLowerCase()
  const style = exchangeStyles[ex] || 'bg-gray-500/20 text-gray-400 border-gray-500/30'
  const sizeClass = size === 'sm' ? 'text-[10px] px-1.5 py-0' : 'text-xs'

  return (
    <Badge
      variant="outline"
      title={EXCHANGE_PRICE_NOTES[ex] || EXCHANGE_DISPLAY_NAMES[ex] || exchange}
      className={cn('font-medium uppercase', sizeClass, style, className)}
    >
      {EXCHANGE_DISPLAY_NAMES[ex] || exchange}{['upbit', 'bithumb'].includes(ex) ? ' ≈USDT' : ''}
    </Badge>
  )
}
